import styled from 'styled-components';
import { Radio, Select, Input, Space, Typography } from 'antd';

const { Text } = Typography;
const { TextArea } = Input;

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const DrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const FullWidthSpace = styled(Space)`
  width: 100%;
`;

export const FieldSpacing = styled.div`
  margin-top: 8px;
`;

export const DayRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FullWidthSelect = styled(Select)`
  width: 100%;
`;

export const SubscribersTextArea = styled(TextArea)`
  margin-top: 8px;
`;

export const ErrorText = styled(Text)`
  font-size: 12px;
`;

export const DrawerFooter = styled.div`
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  margin-top: 16px;
`;
